export enum PaymentEditionType {
  AddAmount = 1,
  SubtractAmount = 2,
}